/* global VERSION */
import commitActionFactory, { mockRes, prefix, reqToJSON } from './commitActionFactory';

import { Session } from 'session-controller';
import config from 'config';
import getObjectProperty from 'get-object-property';
import getURLParam from './getURLParam';
import logger from 'utils/Logger';
import { merge } from 'object-state-storage';
import request from 'superagent';
import setURLParam from './setURLParam';

export default class SessionController extends Session {
  constructor(mountPoint, controllers) {
    super(mountPoint, controllers);

    Object.assign(this.context, {
      currentProcessRequest: this.currentProcessRequest.bind(this),
      commitActionFactory,
      mountControllerWithProcess: this.mountControllerWithProcess.bind(this),
    });

    if (config.api.pathname) {
      const req = this.currentProcessRequest(getURLParam('sessionId')).end((err, res) => {
        if (!res) {
          res = mockRes(req);
        }
        try {
          if (!err && res.ok) {
            const { sessionId } = res.body.currentProcess;
            // set sessionId urlParam and context param
            setURLParam('sessionId', sessionId);
            Object.assign(this.context, { sessionId });
            this.mountControllerWithProcess(res.body.currentProcess);
          } else if (res && res.body.type === 'PhaseNotActive') {
            logger.warn(err, {
              state: this.state,
              req: reqToJSON(getObjectProperty(() => res.req), {}, false),
              res: res,
            });
            this.mountController('ErrorController', res.body);
          } else {
            logger.error(err, {
              state: this.state,
              req: reqToJSON(getObjectProperty(() => res.req), {}, false),
              res: res,
            });
            this.mountController('ErrorController', res.body);
          }
        } catch (enclosedError) {
          logger.error(enclosedError, { state: this.store.state });
        }
      });
    }
  }
  mountControllerWithProcess(currentProcess) {
    const { data, type } = currentProcess;
    const payload = merge(data, { type });
    const types = {
      ERROR: 'ErrorController',
      DISCLAIMER: 'DisclaimerController',
      START: 'StartController',
      ASSESSMENT: 'AssessmentController',
      FINISH: 'FinishController',
    };
    this.mountController(types[type], payload);
  }
  currentProcessRequest(sessionId) {
    const requestId = Math.random()
      .toString(36)
      .substr(2, 24);

    return request
      .get('/session')
      .use(prefix)
      .set('XIT-Session-Id', sessionId)
      .set('XIT-Request-Id', requestId)
      .set('XIT-Client-Version', VERSION)
      .set('XIT-Preview', getURLParam('preview'))
      .withCredentials();
  }
}



// WEBPACK FOOTER //
// ./src/controllers/Session/index.js